"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleTransitionsSchema = void 0;
exports.LifecycleTransitionsSchema = {
    "$id": "https://www.redbull.com/schemas/system/ext/scheduled-transition.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "LifecycleTransitions",
    "description": "Planned publish/unpublish transitions for a resources.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:system:ext:scheduled-transition"
            ]
        },
        "executionTimestamp": {
            "type": "string",
            "format": "date-time"
        },
        "transitionMessage": {
            "type": "string",
            "description": "Optional information message, e.g. specific error message why a transition was not performed"
        },
        "transitionStatus": {
            "type": "string",
            "description": "Status of the transition",
            "enum": [
                "ERROR",
                "EXECUTED",
                "IN_SYNC_SKIPPED",
                "SCHEDULED"
            ]
        },
        "transitionTo": {
            "type": "string",
            "enum": [
                "PUBLISHED",
                "UNPUBLISHED"
            ]
        }
    },
    "required": [
        "executionTimestamp",
        "transitionTo",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NoZWR1bGVkLXRyYW5zaXRpb24uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvc3lzdGVtL2V4dC9zY2hlZHVsZWQtdHJhbnNpdGlvbi5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwwQkFBMEIsR0FBRztJQUN4QyxLQUFLLEVBQUUsNkVBQTZFO0lBQ3BGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHNCQUFzQjtJQUMvQixhQUFhLEVBQUUsd0RBQXdEO0lBQ3ZFLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHFDQUFxQzthQUN0QztTQUNGO1FBQ0Qsb0JBQW9CLEVBQUU7WUFDcEIsTUFBTSxFQUFFLFFBQVE7WUFDaEIsUUFBUSxFQUFFLFdBQVc7U0FDdEI7UUFDRCxtQkFBbUIsRUFBRTtZQUNuQixNQUFNLEVBQUUsUUFBUTtZQUNoQixhQUFhLEVBQUUsOEZBQThGO1NBQzlHO1FBQ0Qsa0JBQWtCLEVBQUU7WUFDbEIsTUFBTSxFQUFFLFFBQVE7WUFDaEIsYUFBYSxFQUFFLDBCQUEwQjtZQUN6QyxNQUFNLEVBQUU7Z0JBQ04sT0FBTztnQkFDUCxVQUFVO2dCQUNWLGlCQUFpQjtnQkFDakIsV0FBVzthQUNaO1NBQ0Y7UUFDRCxjQUFjLEVBQUU7WUFDZCxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sV0FBVztnQkFDWCxhQUFhO2FBQ2Q7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1Ysb0JBQW9CO1FBQ3BCLGNBQWM7UUFDZCxNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=